<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="appointmentHistoryGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'appointment-history-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [visible]="true" [displayMode]="'full'" [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>
            <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">History</div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="'employee.name'" caption="Updated By" cellTemplate="employee" [minWidth]="250"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" caption="Date" [minWidth]="100" cellTemplate="created" [sortOrder]="'desc'"></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" caption="Status" [minWidth]="50" cellTemplate="status"
                [lookup]="{ dataSource: statusOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: statusOptions }">
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('location')" caption="Location" [minWidth]="50" cellTemplate="enum"
                [lookup]="{ dataSource: shuntLocationOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: shuntLocationOptions }">
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('number')" caption="Number" [minWidth]="50"></dxi-column>
            <dxi-column [dataField]="gridFieldName('shuntPriority')" caption="Priority" [minWidth]="25" cellTemplate="shuntPriority"
                [lookup]="{ dataSource: shuntPriorityOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: shuntPriorityOptions }">
            </dxi-column>
            <dxi-column [dataField]="'assignedEmployee.name'" caption="Employee" cellTemplate="assignedEmployee" [minWidth]="250"></dxi-column>
            <dxi-column [dataField]="gridFieldName('stagingLane')" caption="Staging Lane" [minWidth]="50" cellTemplate="stagingLane"
                [lookup]="{ dataSource: stagingLaneOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: stagingLaneOptions }">
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('notes')" caption="Note" [minWidth]="50" [visible]="false"></dxi-column>
            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'shuntPriority'">
                @if (getCellData(cellInfo).shuntPriority !== null) {
                <span class="badge" [ngClass]="getShuntPriorityBadgeClass(getCellData(cellInfo).shuntPriority)">
                    {{ cellInfo.value | shuntPriority}}
                </span>
                }
            </div>
            <div *dxTemplate="let cellInfo of 'enum'">
                {{ cellInfo.value | capitalCase }}
            </div>
            <div *dxTemplate="let cellInfo of 'stagingLane'">
                @if (getCellData(cellInfo).stagingLane !== null) {
                {{ cellInfo.value | stagingLane }}
                }
            </div>
            <div *dxTemplate="let cellInfo of 'created'">
                {{ getCellData(cellInfo).created | date: dateTimeFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'employee'">
                <user-avatar-email [email]="getCellData(cellInfo).employee.email"
                    [name]="getCellData(cellInfo).employee.name" [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                    [employeeId]="getCellData(cellInfo).employee.id">
                </user-avatar-email>
            </div>
            <div *dxTemplate="let cellInfo of 'assignedEmployee'">
                @if(getCellData(cellInfo).assignedEmployee !== undefined)
                {
                <user-avatar-email [email]="getCellData(cellInfo).assignedEmployee.email"
                        [name]="getCellData(cellInfo).assignedEmployee.name" [avatarUrl]="getCellData(cellInfo).assignedEmployee.avatarUrl"
                    [employeeId]="getCellData(cellInfo).assignedEmployee.id">
                </user-avatar-email>
                }
            </div>
        </dx-data-grid>
    </div>

    <filter-panel [(isOpened)]="isFilterPanelOpened" (onSearch)="applyFilters()" (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()">
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="'employee.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Updated By', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Request Date', stylingMode: 'filled', displayFormat: 'shortDate' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('status')" editorType="dxSelectBox" [editorOptions]="{
                    placeholder: 'Status',
                    stylingMode: 'filled',
                    items: statusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }"></dxi-item>
            <dxi-item [dataField]="filterModelName('location')" editorType="dxSelectBox" [editorOptions]="{
                    placeholder: 'Location',
                    stylingMode: 'filled',
                    items: shuntLocationOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }"></dxi-item>
            <dxi-item [dataField]="filterModelName('shuntPriority')" editorType="dxSelectBox" [editorOptions]="{
                    placeholder: 'Priority',
                    stylingMode: 'filled',
                    items: shuntPriorityOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }"></dxi-item>
            <dxi-item [dataField]="'number'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Number', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="'assignedEmployee.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('stagingLane')" editorType="dxSelectBox" [editorOptions]="{
                    placeholder: 'Staging Lane',
                    stylingMode: 'filled',
                    items: stagingLaneOptions,
                    valueExpr: 'value',
                    displayExpr: 'text',
                    showClearButton: true
                }"></dxi-item>
            <dxi-item [dataField]="'notes'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Note', stylingMode: 'filled' }" [label]="{ text: 'Note' }"></dxi-item>
        </dx-form>
    </filter-panel>
</div>
